import { render, staticRenderFns } from "./CheckExamResult.vue?vue&type=template&id=5d00d215&scoped=true&"
import script from "./CheckExamResult.vue?vue&type=script&lang=js&"
export * from "./CheckExamResult.vue?vue&type=script&lang=js&"
import style0 from "./CheckExamResult.vue?vue&type=style&index=0&id=5d00d215&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d00d215",
  null
  
)

export default component.exports